var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_1",
    d: "m42.5,0.003c-23.472,0 -42.5,19.028 -42.5,42.5s19.028,42.5 42.5,42.5s42.5,-19.027 42.5,-42.5s-19.028,-42.5 -42.5,-42.5zm-0.212,66.267c0,0 -1.972,1.311 -3.32,1.305c-0.12,0.055 -0.191,0.087 -0.191,0.087l0.003,-0.087c-0.283,-0.013 -0.568,-0.053 -0.855,-0.125l-0.426,-0.105c-2.354,-0.584 -3.6,-2.918 -3.014,-5.271l3.277,-13.211l1.479,-5.967c1.376,-5.54 -4.363,1.178 -5.54,-1.374c-0.777,-1.687 4.464,-5.227 8.293,-7.896c0,0 1.97,-1.309 3.319,-1.304c0.121,-0.056 0.192,-0.087 0.192,-0.087l-0.005,0.087c0.285,0.013 0.57,0.053 0.857,0.124l0.426,0.106c2.354,0.584 3.788,2.965 3.204,5.318l-3.276,13.212l-1.482,5.967c-1.374,5.54 4.27,-1.204 5.446,1.351c0.777,1.685 -4.559,5.201 -8.387,7.87zm8.306,-41.294c-0.818,3.295 -4.152,5.304 -7.446,4.486c-3.296,-0.818 -5.305,-4.151 -4.487,-7.447c0.818,-3.296 4.152,-5.304 7.446,-4.486c3.296,0.817 5.304,4.151 4.487,7.447z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b6c887b0ecc2b6b16219aa7b0b99a91b.svg";
export { ForwardRef as ReactComponent };